import EyebrowHeader from './EyebrowHeader';
export * from './EyebrowHeader';
export default EyebrowHeader;
